import _DevelopmentProjectService from "../services/development-project-service";
import { IDevelopmentProjectService } from "../types/services/development-project-service";

const instance = new _DevelopmentProjectService();

const DevelopmentProjectService: IDevelopmentProjectService = instance;

export default DevelopmentProjectService;
